import { DBDef_NoteTemplate, ensureDispositionSectionFlag } from '@app/advisor-content-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_onNoteTemplatesUpdated = new ThunderDispatcherV3('__onNoteTemplatesUpdated');
export class ModuleFE_NoteTemplate_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_NoteTemplate, dispatch_onNoteTemplatesUpdated);
        this._v1 = {};
        this.registerVersionUpgradeProcessor('1.0.2', this.upgrade_102);
    }
    upgrade_102 = async (items) => {
        items.forEach(item => ensureDispositionSectionFlag(item.sections));
    };
    // ######################## Search ########################
    __searchFilterMapper = (item) => [item.label, item._id];
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.dbKey,
                results: items.map(item => ({
                    _id: item._id,
                    uiLabel: item.label,
                }))
            }];
    };
}
export const ModuleFE_NoteTemplate = new ModuleFE_NoteTemplate_Class();
//# sourceMappingURL=ModuleFE_NoteTemplate.js.map